<template>
    <div id="app">

<!--Location-->
        <v-card style="width: 100%; height: 100%">

            <v-card flat style="float: left; width: 50%; height: 100%">

                <v-overlay
                        absolute
                        opacity="0.95"
                        color="white"
                        :value="findingLocation">
                    <v-card flat style="width: 30vw; height: 100%" color="rgba(0,0,0,0)">

                        <div style="width: 100%; height: 60%; display: flex; justify-content: center; align-items: center; color: rgba(0,0,0,0.8); font-size: 4.5vh; font-weight: bold">
                            Determining Your Location
                        </div>

                        <div style="width: 100%; height: 40%;">
                            <v-progress-linear
                                    indeterminate
                                    color="black"
                                    rounded
                                    height="10px"
                            ></v-progress-linear>
                        </div>

                    </v-card>
                </v-overlay>
                <div style="width: 100%; height: 10%; font-weight: bold; font-size: 3vh; color: rgba(0,0,0,0.7); display: flex; justify-content: center; align-items: center">
                    Location
                </div>

                <div style="width: 100%; height: 40%; display: flex; justify-content: center; align-items: center">
                    <v-icon style="color: rgba(0,0,0,0.7); font-size: 22vh"> fas fa-hotel</v-icon>
                    <v-icon v-if="atCallCentre == false" color="red" style="color: rgba(0,0,0,0.7); font-size: 40vh; position: absolute"> fas fa-ban</v-icon>
                </div>
                <div v-if="location" style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; color: rgba(0,0,0,0.7); font-weight: bold; font-size: 5vh">
                   {{locationText}}
                </div>
                <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; color: rgba(0,0,0,0.7); font-weight: bold; font-size: 3vh">
                    <div style="width: 100%; height: 10%; display: flex; justify-content: center; align-items: center; float: left">
                        <v-btn @click="showOnMaps" color="red" style="width: 30%; color:White; text-transform: none !important;">
                            <div style="text-decoration: none !important;">Where am I?</div>
                           <v-icon style="padding-left: 10%; font-size: 1.5vw">fas fa-map-marker-alt</v-icon>
                        </v-btn>
                    </div>
                </div>
                <div style="width: 100%; height: 10%" v-if="location">
                    {{ location.coords.latitude }}, {{ location.coords.longitude}}
                </div>
            </v-card>

<!--Notifications-->
            <v-card flat style="float: left; width: 50%; height: 100%">

                <div style="width: 100%; height: 10%; font-weight: bold; font-size: 3vh; color: rgba(0,0,0,0.7); display: flex; justify-content: center; align-items: center">
                    Notification
                </div>

                <div style="width: 100%; height: 70%">
                    <div style="width: 100%; height: 16.5%; display: flex; justify-content: center; align-items: center">
                        <v-text-field style="padding-left: 20%; padding-right: 20%" solo rounded v-model="notification.title" label="Title" ></v-text-field>
                    </div>
                    <div style="width: 100%; height: 16.5%; display: flex; justify-content: center; align-items: center">
                        <v-text-field style="padding-left: 20%; padding-right: 20%" solo rounded v-model="notification.body" label="Body" ></v-text-field>
                    </div>
                    <div style="width: 100%; height: 16.5%; display: flex; justify-content: center; align-items: center">
                        <v-text-field style="padding-left: 20%; padding-right: 20%" solo rounded v-model="notification.data" label="Data" ></v-text-field>
                    </div>
                    <div style="width: 100%; height: 16.5%; display: flex; justify-content: center; align-items: center">
                        <v-text-field style="padding-left: 20%; padding-right: 20%" solo rounded v-model="notification.image" label="Image URL" ></v-text-field>
                    </div>
                    <div style="width: 100%; height: 16.5%; display: flex; justify-content: center; align-items: center">
                        <v-text-field style="padding-left: 20%; padding-right: 20%" solo rounded v-model="notification.badge" label="Badge URL" ></v-text-field>
                    </div>
                    <div style="width: 100%; height: 16.5%; display: flex; justify-content: center; align-items: center">
                        <v-text-field style="padding-left: 20%; padding-right: 20%" solo rounded v-model="notification.icon" label="Icon URL" ></v-text-field>
                    </div>
                </div>
                <div style="width: 100%; height: 16.5%; display: flex; justify-content: center; align-items: center">
                    <v-btn color="blue" style="color: white" @click="sendNotification" >Notify</v-btn>
                </div>
            </v-card>
        </v-card>
    </div>
</template>

<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { AXIOS } from '../../http-common'
import VueApexCharts from 'vue-apexcharts'

Vue.use(Vuetify)
Vue.use(VueApexCharts)
export default {

  components: {
    apexcharts: VueApexCharts
  },

  props: [
    'statsOpen', 'statsUpdate'
  ],
  data () {
    return {
      findingLocation: true,
      atCallCentre: false,
      location: null,
      gettingLocation: false,
      locationText: '',
      notification: {
        body: 'Body',
        data: 'Data',
        title: 'Title',
        icon: 'https://s3-eu-west-1.amazonaws.com/www.txtitchat.com/APN-Logo-01.png',
        image: 'https://s3-eu-west-1.amazonaws.com/www.txtitchat.com/APN-Logo-01.png',
        badge: 'https://s3-eu-west-1.amazonaws.com/www.txtitchat.com/APN-Logo-01.png'
      }
    }
  },
  watch: {
  },
  created: function () {
    this.getLocation()
  },
  computed: {

  },
  methods: {
    getLocation () {
      // do we support geolocation
      if (!('geolocation' in navigator)) {
        this.errorStr = 'Geolocation is not available.'
        return
      }
      this.gettingLocation = true
      // get position
      navigator.geolocation.getCurrentPosition(pos => {
        this.gettingLocation = false
        this.location = pos
        this.amIAtCallCentre()
        this.findingLocation = false
      }, err => {
        this.gettingLocation = false
        this.errorStr = err.message
      })
    },
    amIAtCallCentre () {
      if (this.location.coords.latitude >= '53.795478' && this.location.coords.latitude <= '53.8060441' && this.location.coords.longitude <= '-1.534496' && this.location.coords.longitude >= '-1.542131') {
        this.atCallCentre = true
        this.locationText = "You're at the office"
      } else {
        this.atCallCentre = false
        this.locationText = " You're not in the office"
      }
    },

    showOnMaps () {
      window.open('https://www.google.com/maps/place/@' + this.location.coords.latitude + ',' + this.location.coords.longitude)
    },

    sendNotification (body, icon, title) {
      var options = {
        body: this.notification.body,
        data: this.notification.data,
        timestamp: new Date(),
        icon: this.notification.icon,
        image: this.notification.image,
        badge: this.notification.badge
      }
      var title = this.notification.title
      var n = new Notification(title, options)
    }

  }
}
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;

        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
        padding: 1%;
    }

</style>
